export default __webpack_public_path__ + "static/media/tenniscourt.37614852.jpeg";